// extracted by mini-css-extract-plugin
module.exports = {"requestName":"styles_requestName__4QtOI"};